import React from "react";
import { DayofIcon } from "../components";
import { Skeleton } from "../components/ui/skeleton";
import { Link } from "react-router-dom";

const HtmlRenderer = ({ htmlContent }) => {
  return (
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

const DayCard = ({ data, isLoading }) => {
  
  const { date, label, title, category, description } = data || {};

  return (
    <div className="">
      <div className="flex justify-between mb-4">
        {isLoading ? (
          <Skeleton className="w-20 h-5" />
        ) : (
          date && (
            <h5 className="font-bold leading-5 text-gray-900 font-base">
              {date}
            </h5>
          )
        )}

        {isLoading ? (
          <Skeleton className="w-10 h-5" />
        ) : label === "Today" ? (
          <span className="font-bold text-gray-600">Today</span>
        ) : (
          <p className="font-normal leading-5 text-gray-600 font-base">
            {label}
          </p>
        )}
      </div>

      <div className="p-4 rounded-lg bg-white-50">
        <div className="flex gap-4 mb-4">
          {isLoading ? (
            <Skeleton className="rounded-lg w-14 h-14" />
          ) : (
            <DayofIcon className="w-14 h-14 text-gold-600" />
          )}

          <div className="flex flex-col gap-1.5">
            {isLoading ? (
              <Skeleton className="w-40 h-6" />
            ) : (
              title && (
                <h5 className="text-xl font-bold leading-6.5 text-gray-900 underline font-cmr">
                  <Link to="/single-day">{title}</Link>
                </h5>
              )
            )}

            {isLoading ? (
              <Skeleton className="w-20 h-5" />
            ) : (
              category && (
                <span className="px-2 py-1 text-xs font-medium leading-4 bg-gold-50 text-gold-500 w-max">
                  {category}
                </span>
              )
            )}
          </div>
        </div>

        {isLoading ? (
          <Skeleton className="w-full h-12" />
        ) : (
          description && (
            <div className="text-gray-600 font-normal text-sm leading-4.5 text-left">
              <HtmlRenderer htmlContent={description} />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DayCard;
